import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalProgressSpinnerService {
  readonly loading$: Observable<boolean>;
  private readonly _loading$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  constructor() {
    this.loading$ = this._loading$.asObservable();
  }

  showLoader(): void {
    this._loading$.next(true);
  }

  hideLoader(): void {
    console.log('Hide loader called');

    this._loading$.next(false);
  }

  setLoader(isLoading: boolean): void {
    this._loading$.next(isLoading);
  }
}
